/**
 * Centralised error-string normalisation for the login form.
 * Keeps user-facing copy out of the form's render path.
 */

const NETWORK_FALLBACK = 'Network error. Please check your connection and try again.';

function _normalize(message, fallback) {
  if (!message || typeof message !== 'string') return fallback;
  // Never display raw HTML to the user
  if (message.includes('<')) return fallback;
  return message;
}

export function parseSendOtpError(err) {
  if (!err) return 'Unable to send OTP. Please try again.';
  if (!err.response) return NETWORK_FALLBACK;
  const detail = err.response?.data?.detail;
  return _normalize(detail, 'Unable to send OTP. Please try again.');
}

export function parseResendOtpError(err) {
  if (!err) return 'Failed to resend OTP. Please try again.';
  if (!err.response) return 'Network error. Please check your connection.';
  const detail = err.response?.data?.detail;
  return _normalize(detail, 'Failed to resend OTP. Please try again.');
}

export function parseVerifyOtpError(err) {
  return err?.response?.data?.detail || 'Invalid OTP.';
}
